import { render, staticRenderFns } from "./session-timeout-modal.vue?vue&type=template&id=2a0be0a0"
import script from "./session-timeout-modal.vue?vue&type=script&lang=js"
export * from "./session-timeout-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports